import {Trans} from '@common/i18n/trans';
import {Button} from '@common/ui/buttons/button';
import {Dialog} from '@common/ui/overlays/dialog/dialog';
import {DialogBody} from '@common/ui/overlays/dialog/dialog-body';
import {DialogHeader} from '@common/ui/overlays/dialog/dialog-header';
import {closeDialog} from '@common/ui/overlays/store/dialog-store';
import {useNavigate} from 'react-router-dom';

function ZeroScoreDialog() {
  const userId = localStorage.getItem('userId');

  const navigate = useNavigate();

  return (
    <Dialog>
      <DialogHeader
        onDismiss={() => {
          closeDialog(ZeroScoreDialog);
        }}
      >
        <p className="leading-7">
          <Trans message="Hello dear friend!" />
        </p>
      </DialogHeader>
      <DialogBody className="w-full leading-6">
        <p>
          <Trans message="Your current points aren’t enough for free access. Thus the download and player links are hidden to you. To enjoy all the features of the site and watch movies and series without limits, you’ll need a few more points." />
        </p>
        <p>
          <Trans message="The good news is: all you have to do is invite a friend!" />
        </p>
        <p>
          <Trans message="Both of you will receive bonus points and get full access to the site’s content!" />
        </p>
        <p>
          <Trans message="Hit the invite button and enjoy!" />
        </p>
        <Button
          variant={'flat'}
          color={'primary'}
          onClick={() => {
            closeDialog(ZeroScoreDialog);
            navigate(`/user/${userId}/user/invite-friends`);
          }}
        >
          <Trans message="Invite" />
        </Button>
      </DialogBody>
    </Dialog>
  );
}

export default ZeroScoreDialog;
